
import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import { Router } from '@angular/router';
import { ApiEvsService } from './ApiEvs.service';

@Injectable()
export class CampaignService extends ApiEvsService {
    constructor(http: Http, router: Router) {
        super(http, router);
    }

    all(query?: any) {
        return this.get('/all-campaigns', query);
    }

    list(query?:any) {
        return this.get('/campaigns', query);
    }

    create(body: any) {
        return this.post('/campaigns',body);
    }

    find(id) {
        return this.get('/campaigns/'+id);
    }

    update(id, body) {
        return this.put('/campaigns/'+id, body);
    }

    delete(id) {
        return this.delete('/campaigns/'+id);
    }

    deleteMany(body) {
        return this.post('/delete-campaigns',body);
    }

    listContact(campaign_id, query?:any) {
        return this.get('/campaigns/'+campaign_id+'/contacts', query);
    }

    allAgentInQueue(campaign_id, query?:any) {
        return this.get('/campaigns/'+campaign_id+'/allAgents', query);
    }

    createCampaignContact(campaign_id, body) {
        return this.post('/campaigns/'+campaign_id+'/contacts', body);
    }

    deleteCampaignContact(campaign_id, body) {
        return this.post('/campaigns/'+campaign_id+'/delete-contacts', body);
    }

    assignAgentCampaign(query?: any) {
        return this.postServer('/outbound/manual', query);
    }
    
}



// WEBPACK FOOTER //
// G:/3csoft/client-final/src/app/common/services/Campaign.service.ts